resourcePaths = '{"rootPath":"","assetsPath":""}';function LocalStore(storeName) {
  this.storeName = storeName || 'UISTORE';
  this.store = {};

  try {
    if (!localStorage.hasOwnProperty(this.storeName)) localStorage.setItem(this.storeName, '{}')
    this.store = JSON.parse(localStorage[this.storeName])
  } catch(e) {
    // console.error('localStorage Error:', e)
   }
}

LocalStore.prototype.save = function() {
  try {
    localStorage.setItem(this.storeName, JSON.stringify(this.store))
  } catch(e) {
     // console.error('localStorage Error:', e)
   }
}

LocalStore.prototype.update = function() {
  try {
    this.store = JSON.parse(localStorage[this.storeName])
  } catch(e) {
    // console.error('localStorage Error:', e)
   }
}
